@if (!isMobile) {
  <button
    mat-raised-button
    class="actions-menu__button"
    data-testid="meet-action-button"
    [ngClass] = "{'actions-menu__button-pressed': menuOpen,
    'actions-menu__button-disabled': selectedCustomerIds.length === 0 || disableActionMenu}"
    [cfaLoading]="isLoading"
    [disabled]="selectedCustomerIds.length === 0 || disableActionMenu"
    [matMenuTriggerFor]="menu"
    (menuOpened)="isOpened()"
    (menuClosed)="isClosed()">
    @if (selectedCustomerIds.length > 0) {
      <div
        class="actions-menu__badge" data-testid="meet-action-menu-badge"
        [ngClass] = "{'actions-menu__badge-pressed': menuOpen}">
        {{selectedCustomerIds.length}}
      </div>
    }
    Actions
  </button>
}

@if ((isMobile && selectedCustomerIds.length > 0) && !disableActionMenu) {
  <div
    fxLayout="row"
    fxLayoutAlign="center center">
    <i class="material-icons actions-menu__mobile-dropdown-enabled"
      [matMenuTriggerFor]="menu"
    [ngClass] = "{'actions-menu__button-pressed': menuOpen}">more_vert</i>
    <div class="actions-menu__badge-mobile" fxLayout="column" fxLayoutAlign="center center"
      [ngClass] = "{'actions-menu__badge-pressed': menuOpen}">
      {{selectedCustomerIds.length}}
    </div>
  </div>
}

@if ((isMobile && selectedCustomerIds.length > 0) && disableActionMenu) {
  <i
  class="material-icons">more_vert</i>
}

@if ((isMobile && selectedCustomerIds.length === 0)) {
  <i
  class="material-icons actions-menu__mobile-dropdown-disabled">more_vert</i>
}

<mat-menu #menu="matMenu">
  @if (showCreateSavedGroupOption) {
    <button data-testid="create-saved-group-button"
      (click)="createSavedGroup()"
      mat-menu-item
      [disabled]="disableCreateSavedGroup$ | async">
      Create Saved Group
    </button>
  }
  @if (showCreateSavedGroupOption) {
    <mat-divider class="actions-menu__display-mat-divider"></mat-divider>
  }

  @if (!canMakeInactive) {
    @if (!(isAllSendingDisabled$ | async)) {
      @if (!(isRewardsSendingDisabled$ | async)) {
        <button data-testid="send-reward-button" (click)="checkForUnsavedChanges(engageWithCustomer, 0)" mat-menu-item>
          Send Reward
        </button>
      }
      <button data-testid="send-event-button" (click)="checkForUnsavedChanges(engageWithCustomer, 1)" mat-menu-item>
        Send Event
      </button>
      <button data-testid="send-email-button" (click)="checkForUnsavedChanges(engageWithCustomer, 2)" mat-menu-item>
        Send Email
      </button>
    }
    @if (!(isAllSendingDisabled$ | async)) {
      <mat-divider class="actions-menu__display-mat-divider"></mat-divider>
    }
    @if (!isMobile) {
      <button data-testid="move-to-inactive-button" (click)="makeInactive()" mat-menu-item>
        Move to Inactive List
      </button>
    }
  }

  @if (canMakeInactive) {
    <button data-testid="move-to-active-button" mat-menu-item (click)="makeActive()">
      Move to Active List
    </button>
  }
</mat-menu>
